import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-2xl overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex p-4 border-b" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-2xl font-semibold" }, "Confirm Email")
], -1)
const _hoisted_3 = { class: "flex items-center p-4 text-sm border-b" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-16" }, "Subject:", -1)
const _hoisted_5 = {
  class: "h-64 p-4 overflow-y-scroll border-b shadow-inner",
  ref: "recommendationTables"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"font-size":"16px","padding":"5px"} }
const _hoisted_8 = /*#__PURE__*/_createVNode("td", { style: {"font-size":"16px"} }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("td", { style: {"font-size":"16px","padding":"5px"} }, "Overall Comment:", -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { style: {"font-size":"12px","padding":"5px","margin":"10px"} }
const _hoisted_13 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { style: {"font-size":"16px","padding":"5px"} }, "Maneuvers:")
], -1)
const _hoisted_14 = { style: {"font-size":"12px","padding":"5px","margin":"10px"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createVNode("td", { style: {"font-size":"12px","padding":"5px","padding-left":"20px"} }, " Reason for grade: ", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"font-size":"12px","padding":"5px","padding-left":"30px"} }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createVNode("td", { style: {"font-size":"12px","padding":"5px","padding-left":"20px"} }, " Recommendation: ", -1)
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { style: {"font-size":"12px","padding":"5px","padding-left":"30px"} }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/_createVNode("td", { style: {"font-size":"12px","padding":"5px","padding-left":"20px"} }, " Comments: ", -1)
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { style: {"font-size":"12px","padding":"5px","padding-left":"30px"} }
const _hoisted_27 = { class: "flex items-center p-4" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Email student")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")
  const _component_modal = _resolveComponent("modal")

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_modal, {
        key: 0,
        onClose: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createVNode("section", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.subject), 1)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("table", null, [
                (_ctx.event.overallGrade)
                  ? (_openBlock(), _createBlock("tr", _hoisted_6, [
                      _createVNode("td", _hoisted_7, " Overall Grade (" + _toDisplayString(_ctx.getGrade(_ctx.event.overallGrade)) + ") ", 1),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.event.overallComments)
                  ? (_openBlock(), _createBlock("tr", _hoisted_9, [
                      _hoisted_10
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.event.overallComments)
                  ? (_openBlock(), _createBlock("tr", _hoisted_11, [
                      _createVNode("td", _hoisted_12, _toDisplayString(_ctx.event.overallComments), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_13
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendations, (recommendation, index) => {
                return (_openBlock(), _createBlock("table", {
                  key: index,
                  style: {"width":"500px","margin-bottom":"10px","padding-bottom":"10px","font-family":"Arial, sans-serif"}
                }, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_14, _toDisplayString(recommendation.mif.unFormattedManeuver) + " (" + _toDisplayString(_ctx.getGrade(recommendation.grade)) + ") ", 1)
                  ]),
                  (recommendation.reason.display != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_15, [
                        _hoisted_16
                      ]))
                    : _createCommentVNode("", true),
                  (recommendation.reason.display != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_17, [
                        _createVNode("td", _hoisted_18, " - " + _toDisplayString(recommendation.reason.display), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (recommendation.correction.display != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_19, [
                        _hoisted_20
                      ]))
                    : _createCommentVNode("", true),
                  (recommendation.correction.display != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_21, [
                        _createVNode("td", _hoisted_22, " - " + _toDisplayString(recommendation.correction.display), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (recommendation.comments != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_23, [
                        _hoisted_24
                      ]))
                    : _createCommentVNode("", true),
                  (recommendation.comments != '')
                    ? (_openBlock(), _createBlock("tr", _hoisted_25, [
                        _createVNode("td", _hoisted_26, " - " + _toDisplayString(recommendation.comments), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512),
            _createVNode("div", _hoisted_27, [
              _createVNode("span", {
                class: "pr-6 ml-auto text-xs cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                "data-testid": "cancel-button"
              }, " Cancel"),
              _createVNode(_component_button_component, {
                onClick: _ctx.confirm,
                "data-testid": "confirm-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}